/**
 * External dependencies
 */
import { Component } from 'react';
import { connect } from 'react-redux';
import { debounce } from 'lodash';

/**
 * Internal dependencies.
 */
import { getDocumentHeadTitle } from 'state/document-head/selectors';
import { setDocumentHeadTitle as setTitle } from 'state/document-head/actions';

class DocumentHead extends Component {
    
    UNSAFE_componentWillMount() {
        const { title } = this.props;
        if (this.props.title !== undefined) {
            this.props.setTitle(title);
        }
    }   

    UNSAFE_componentDidMount() {
        this.setFormattedTitle(this.props.formattedTitle);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        
        if (nextProps.title !== undefined && this.props.title !== nextProps.title) {
            this.props.setTitle(nextProps.title);
        }

        if (nextProps.formattedTitle !== this.props.formattedTitle) {
            this.setFormattedTitle(nextProps.formattedTitle);
        }
    }

    setFormattedTitle = debounce((title) => {
        document.title = title;
    });

    render() {
        return null;
    }
    
}

export default connect(
    (state) => ({
        formattedTitle: getDocumentHeadTitle(state),
    }),
    {
        setTitle,
    },
)(DocumentHead);
